var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _g3, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 29,
    viewBox: "0 0 154 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3318_1679",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 6,
    width: 20,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.763 15.4658L153.226 6.89057L148.912 6.83276L143.774 12.682L138.671 6.86979L134.468 6.89057L141.768 15.4658L134.283 24.1341H138.742L143.777 18.0543L148.768 24.0838H153.264L145.763 15.4658Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3318_1679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.352 7.1814H137.225V7.49271H172.352V7.1814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 7.90796H137.225V8.21928H172.352V7.90796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 8.63452H137.225V8.94584H172.352V8.63452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 9.36108H137.225V9.6724H172.352V9.36108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 10.0869H137.225V10.3982H172.352V10.0869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 10.8135H137.225V11.1248H172.352V10.8135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 11.54H137.225V11.8514H172.352V11.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 12.2666H137.225V12.5779H172.352V12.2666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 12.9927H137.225V13.304H172.352V12.9927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 13.7195H137.225V14.0308H172.352V13.7195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 14.4456H137.225V14.7569H172.352V14.4456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 15.1721H137.225V15.4834H172.352V15.1721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 15.8982H137.225V16.2095H172.352V15.8982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 16.6248H137.225V16.9361H172.352V16.6248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 17.3511H137.225V17.6624H172.352V17.3511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 18.0776H137.225V18.389H172.352V18.0776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 18.8037H137.225V19.115H172.352V18.8037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 19.5303H137.225V19.8416H172.352V19.5303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 20.2566H137.225V20.5679H172.352V20.2566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 20.9832H137.225V21.2945H172.352V20.9832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 21.7095H137.225V22.0208H172.352V21.7095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 22.4363H137.225V22.7476H172.352V22.4363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 23.1621H137.225V23.4734H172.352V23.1621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.352 23.8887H137.225V24.2H172.352V23.8887Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2272 13.7189V12.4875C52.2272 12.048 52.1795 11.6202 52.0887 11.2095C51.6316 9.14396 50.0916 7.51734 48.1343 7.03538C47.7455 6.93875 47.3401 6.88843 46.9236 6.88843H36.8598C35.4616 6.88843 34.3281 8.02189 34.3281 9.42009V18.5982C34.3281 18.876 34.3474 19.1491 34.3844 19.4161C34.4059 19.5716 34.4339 19.7254 34.4668 19.8766C34.9239 21.9429 36.1478 23.5442 38.1045 24.0267C38.3194 24.0796 38.5389 24.1186 38.7629 24.1431C38.9442 24.163 39.1284 24.1731 39.3149 24.1731H51.3357C51.8281 24.1731 52.2272 23.774 52.2272 23.2816V19.8907H48.6754V20.5409C48.6754 20.7703 48.4895 20.9563 48.2601 20.9563H41.0258C40.9041 20.9563 40.7838 20.9497 40.6655 20.9367C40.5192 20.9207 40.376 20.8952 40.2356 20.8607C38.9582 20.5457 37.9524 19.7011 37.654 18.352C37.6325 18.2533 37.6143 18.1529 37.6002 18.0514C37.576 17.8771 37.5635 17.6988 37.5635 17.5174V10.4812C37.5635 10.1538 37.8289 9.88833 38.1563 9.88833H45.5485C45.8203 9.88833 46.085 9.92119 46.3389 9.98427C47.6168 10.2989 48.6222 11.3609 48.9206 12.7095C48.98 12.9776 49.0111 13.2569 49.0111 13.5438V13.7189L52.2272 13.7189Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7133 12.4968V14.2619C87.7133 14.6909 87.6679 15.1086 87.5807 15.5103C87.5784 15.5204 87.5763 15.5299 87.574 15.5403C87.1176 17.6059 85.9416 18.7653 83.9843 19.247C83.7694 19.3004 83.5494 19.3396 83.3254 19.3642C83.144 19.384 82.9599 19.3942 82.7736 19.3942L75.2083 19.3846V24.1731H71.9922V6.88843L82.4096 6.8978C82.8261 6.8978 83.2315 6.94812 83.6203 7.04475C85.5777 7.52671 87.1176 9.15333 87.5747 11.2189C87.6655 11.6295 87.7133 12.0574 87.7133 12.4968ZM82.8332 16.1761C83.7026 16.1761 84.4074 15.4319 84.4074 14.5136L84.4886 11.8236C84.4886 10.9059 83.7838 10.1617 82.9145 10.1617L75.2895 10.1524L75.2083 16.1667L82.8332 16.1761Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.128 10.0102H98.9956V24.0718H95.7469V10.0102H89.1875V6.78711H105.128V10.0102Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3318_1679",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 6,
    width: 4,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 24.1732V6.92969H124.645V24.1732H121.6Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3318_1679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.231 6.89771H105.104V7.20902H140.231V6.89771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 7.62402H105.104V7.93534H140.231V7.62402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 8.35059H105.104V8.6619H140.231V8.35059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 9.0769H105.104V9.38822H140.231V9.0769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 9.80371H105.104V10.115H140.231V9.80371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 10.5295H105.104V10.8409H140.231V10.5295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 11.2561H105.104V11.5674H140.231V11.2561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 11.9824H105.104V12.2937H140.231V11.9824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 12.709H105.104V13.0203H140.231V12.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 13.4353H105.104V13.7466H140.231V13.4353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 14.1619H105.104V14.4732H140.231V14.1619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 14.8879H105.104V15.1993H140.231V14.8879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 15.6145H105.104V15.9258H140.231V15.6145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 16.3408H105.104V16.6521H140.231V16.3408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 17.0674H105.104V17.3787H140.231V17.0674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 17.7935H105.104V18.1048H140.231V17.7935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 18.5203H105.104V18.8316H140.231V18.5203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 19.2463H105.104V19.5577H140.231V19.2463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 19.9729H105.104V20.2842H140.231V19.9729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 20.699H105.104V21.0103H140.231V20.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 21.4255H105.104V21.7369H140.231V21.4255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 22.1521H105.104V22.4634H140.231V22.1521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 22.8787H105.104V23.19H140.231V22.8787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.231 23.6052H105.104V23.9165H140.231V23.6052Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3318_1679",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 6,
    width: 19,
    height: 19
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.854 16.3828L113.75 16.118L113.089 14.4358L111.759 11.0538H111.248L109.918 14.4358L109.257 16.118L107.928 19.5L106.083 24.1939H102.713L105.265 17.7006L106.963 13.3795L107.808 11.2303L109.507 6.90918H111.214H113.553L115.252 11.2303L116.096 13.3795L117.795 17.7006L120.347 24.1939H116.924L115.079 19.5L115.015 19.3366",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3318_1679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.244 6.92651H92.1172V7.23783H127.244V6.92651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 7.65308H92.1172V7.96439H127.244V7.65308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 8.37915H92.1172V8.69047H127.244V8.37915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 9.10571H92.1172V9.41703H127.244V9.10571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 9.83203H92.1172V10.1433H127.244V9.83203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 10.5586H92.1172V10.8699H127.244V10.5586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 11.2847H92.1172V11.596H127.244V11.2847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 12.0112H92.1172V12.3225H127.244V12.0112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 12.7375H92.1172V13.0489H127.244V12.7375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 13.4641H92.1172V13.7754H127.244V13.4641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 14.1907H92.1172V14.502H127.244V14.1907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 14.9167H92.1172V15.2281H127.244V14.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 15.6433H92.1172V15.9546H127.244V15.6433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 16.3696H92.1172V16.6809H127.244V16.3696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 17.0962H92.1172V17.4075H127.244V17.0962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 17.8228H92.1172V18.1341H127.244V17.8228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 18.5493H92.1172V18.8606H127.244V18.5493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 19.2751H92.1172V19.5865H127.244V19.2751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 20.002H92.1172V20.3133H127.244V20.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 20.728H92.1172V21.0393H127.244V20.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 21.4546H92.1172V21.7659H127.244V21.4546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 22.1809H92.1172V22.4922H127.244V22.1809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 22.9075H92.1172V23.2188H127.244V22.9075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.244 23.6338H92.1172V23.9451H127.244V23.6338Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8479 16.1095L63.224 14.3902L61.8516 10.7617H62.3604L61.0045 14.4273L60.3432 16.1095L59.0137 19.4915L57.169 24.1854H53.6523L56.2543 17.6244L57.953 13.3033L58.7979 11.1541L60.4746 6.88843L62.2997 6.90069L63.7639 6.89456L65.4626 11.2157L66.3073 13.3649L68.0059 17.686L70.5582 24.1793L67.0224 24.1854L65.1774 19.4915L65.1132 19.3281",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.644 6.99706L134.656 19.9427L125.907 6.91327L125.178 6.89819L125.179 11.4453L133.418 24.1903L137.868 24.1113V6.99222L134.644 6.99706Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6805 2.86663L21.5757 15.1532L18.7795 20.7811L17.1655 24.0292L17.1409 24.0214C17.0741 24.1427 17.0045 24.2621 16.9326 24.3797C16.1841 25.6088 15.1617 26.6489 13.9565 27.4114C12.5612 28.2901 10.917 28.7983 9.15754 28.7983C6.11031 28.7983 3.41136 27.2754 1.74622 24.9332C0.646816 23.3868 0 21.4836 0 19.427C0 19.4174 -3.66116e-07 19.4075 0.000367933 19.3979C0.00368428 18.1868 0.232558 17.0288 0.644974 15.9674C0.783183 15.6095 0.942769 15.2619 1.12226 14.9273C1.12447 14.9229 1.12668 14.9184 1.12926 14.9144L1.3467 14.5315L4.35413 9.23308H4.3545L8.16464 2.30273L11.2675 7.70431L10.9878 8.2107L10.5658 8.97399L9.9422 10.09C9.94441 10.0903 9.94662 10.0903 9.94883 10.0907L6.23709 16.8066L5.45575 18.2192C5.30427 18.7006 5.24272 19.2236 5.28658 19.7672C5.43769 21.656 6.91597 23.194 8.75913 23.382C9.45017 23.4524 10.1088 23.3374 10.6933 23.0794C11.478 22.7326 12.1126 22.1049 12.5262 21.3394L12.7727 20.8828L14.7239 17.2698L15.6357 15.308L18.405 9.34733L21.4157 2.86662L27.6805 2.86663Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.565 8.97437L9.94804 10.0911C9.94583 10.0907 9.94362 10.0907 9.94141 10.0904L10.565 8.97437Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3444 14.5317L1.12695 14.9147C1.19624 14.7849 1.26885 14.6574 1.3444 14.5317Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4025 9.34766L15.6331 15.3083L11.265 7.70464L8.16211 2.30307C9.58142 -0.238874 13.1679 -0.225235 14.5684 2.32776L18.4025 9.34766Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.136 28.9999H23.4986L18.7773 20.7814L21.5736 15.1536L29.136 28.9999Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12651 14.9146C1.12393 14.9186 1.12172 14.923 1.11951 14.9274H1.11914L1.12651 14.9146Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1341 0.00170898L28.9623 0.338573H22.5527L22.7086 0.00170898H29.1341Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7339 0.788086L28.5622 1.12495H22.1895L22.3454 0.788086H28.7339Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 1.57397L28.1613 1.91084H21.8262L21.9821 1.57397H28.3334Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9325 2.36035L27.7608 2.69721H21.4629L21.6188 2.36035H27.9325Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9328 2.36035L27.7611 2.69721L21.4609 2.70201L21.4631 2.69721L21.619 2.36035H27.9328Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 1.57397L28.1613 1.91084H21.8262L21.9821 1.57397H28.3334Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7339 0.788086L28.5622 1.12495H22.1895L22.3454 0.788086H28.7339Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1352 0L29.1341 0.00184092L28.9623 0.338705H22.5527L22.7086 0.00184092L22.7094 0H29.1352Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.f66cab6f0e8250e12b36c71273377dc2.svg";
export { ForwardRef as ReactComponent };